import { Button, Dropdown, Modal, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import "./userprofileheader.scss";
import statusmodalimage from "../../assets/images/status-modal-image.svg";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import duplicatePlusIcon from "../../assets/images/duplicate-plus-icon.svg";
import deactivateicon from "../../assets/images/deactivate-icon.svg";
import resetpasswordicon from "../../assets/images/reset-password-icon.svg";
import loadicon from "../../assets/images/load-icon.svg";
import { useEffect, useRef, useState } from "react";
import { ReactSVG } from "react-svg";
import useUser from "../../Hooks/useUser";
import useAuth from "../../Hooks/useAuth";
import { useNavigate } from "react-router-dom";
import Loading from "../LoadingPage/Loading";
import { toggleClass } from "../../utils/commonUtils";
import { DeleteConfModel } from "../DeleteConfModel/deleteConfModel";
import { toast } from "react-toastify";
import DublicateUserModel from "../DublicateUserModel/DublicateUserModel";
import CustomModal from "../customModal/CustomModal";
import duplicateIcon from "../../assets/images/duplicate-icon.svg";
import { useModulePermissions, PermissionIdentifier, PermissionModule } from "../../utils/permissionUtils";
import ReCAPTCHA from "react-google-recaptcha";
import { useAppSelector } from "../../redux/hooks";
import { selectConfigData } from "../../redux/config/configSlice";

const UserProfileHeader = ({
  selectedUserData,
  updateStatus,
  currentUserId,
}: any) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [showModal, setShowModal] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [showConfirmResetModal, setShowConfirmResetModal] = useState(false);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [resetPasswordResult, setResetPasswordResult] = useState("");
  const [copyTooltipText, setCopyTooltipText] = useState("Copy to clipboard");
  const { deleteUserAPI, deleteUserLoading } = useUser();
  const {
    getUserList,
    getUsersListLoading,
    duplicateUserLoading,
    onResetPassword,
    resetPasswordLoading,
  } = useUser();
  const { verifyCaptchaApi } = useAuth();
  const configData = useAppSelector(selectConfigData);
  const navigate = useNavigate();
  const toggleModal = () => {
    toggleClass();
    setShowModal(!showModal);
  };
  const onClose = () => {
    toggleClass();
    setShowModal(!showModal);
  };
  const fetchUserList = () => {
    getUserList({
      searchText: "",
      active: true,
      sortColumn: "",
      sortDirection: ""
    }).then((res: any) => {
      if (res) {
        setUsersList(res);
      }
    });
  };
  const deleteUser = async () => {
    await deleteUserAPI({ id: selectedUserData.id, deletedBy: currentUserId });
    onClose();
    navigate("/users");
  };

  const openConfirmResetModal = () => {
    toggleClass();
    setShowConfirmResetModal(true);
  };

  const closeConfirmResetModal = () => {
    toggleClass();
    setShowConfirmResetModal(false);
    setCaptchaToken(null);
    recaptchaRef.current?.reset();
  };

  const resetPassword = async () => {
    if (!captchaToken) return;
    try {
      await verifyCaptchaApi(captchaToken);
      closeConfirmResetModal();
      const userName = selectedUserData.userName;
      const { result } = await onResetPassword({
        userName,
        updatedBy: currentUserId,
      });
      if (result) {
        if (result.includes("emailed to")) {
          toast.success(result, { autoClose: false });
        } else {
          const password = result.includes(":") ? result.split(":").pop()?.trim() || result : result;
          setResetPasswordResult(password);
          setCopyTooltipText("Copy to clipboard");
          toggleClass();
          setShowResetPasswordModal(true);
        }
      }
    } catch {
      recaptchaRef.current?.reset();
      setCaptchaToken(null);
    }
  };

  const closeResetPasswordModal = () => {
    toggleClass();
    setShowResetPasswordModal(false);
    setResetPasswordResult("");
  };

  const handleCopyPassword = () => {
    navigator.clipboard
      .writeText(resetPasswordResult)
      .then(() => {
        setCopyTooltipText("Copied!");
        setTimeout(() => setCopyTooltipText("Copy to clipboard"), 2000);
      })
      .catch(() => {
        setCopyTooltipText("Failed to copy");
        setTimeout(() => setCopyTooltipText("Copy to clipboard"), 2000);
      });
  };

  const toggleDuplicateModal = () => {
    toggleClass();
    setShowDuplicateModal(!showDuplicateModal);
  };

  const isPermitted = useModulePermissions(PermissionModule.USER_MANAGEMENT);
  const isEditPermitted = isPermitted(PermissionIdentifier.EDIT_USER);
  const isLoadUsagePermitted = isPermitted(PermissionIdentifier.LOAD_USAGE_USER);
  const isDuplicatePermitted = isPermitted(PermissionIdentifier.DUPLICATE_USER);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_USER);
  const isInactivePermitted = isPermitted(PermissionIdentifier.INACTIVE_USER);
  const isResetPasswordPermitted = isPermitted(PermissionIdentifier.RESET_PASSWORD_USER);
  const isAnyActionPermitted = isLoadUsagePermitted || isDuplicatePermitted || isDeletePermitted || isInactivePermitted || isResetPasswordPermitted;

  useEffect(() => {
    fetchUserList();
  }, [])

  return (
    <div className="user-profile-header-wrapper">
      {deleteUserLoading || duplicateUserLoading || resetPasswordLoading || getUsersListLoading ? (
        <Loading />
      ) : null}
      <div className="profile-title-status-box">
        <h2>{selectedUserData.fName + " " + selectedUserData.lName}</h2>
        <div
          className={`status-box 
          ${selectedUserData?.isActive ? "active" : "inactive"}`}
        >
          <span className="status-circle"></span>
          <span className="status-text">
            {selectedUserData?.isActive ? "Active" : "Inactive"}
          </span>
        </div>
      </div>
      <div className="profile-actions-box">
        {isEditPermitted && (
          <div className="edit-btn-box">
            <Button variant="primary" href="/edit-user">
              <i className="bi bi-pencil-square"></i> Edit
            </Button>
          </div>
        )}
        <Dropdown>
          {isAnyActionPermitted && (
            <Dropdown.Toggle variant="link" id="dropdown-basic">
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={threedotvertical}
              />
            </Dropdown.Toggle>
          )}
          <Dropdown.Menu>
            {isLoadUsagePermitted && (
              <Dropdown.Item>
                <ReactSVG
                  style={{ marginLeft: "-3px" }}
                  className="svg-box"
                  wrapper="span"
                  src={loadicon}
                />
                Load Usage
              </Dropdown.Item>
            )}
            {isDuplicatePermitted && (
              <Dropdown.Item onClick={toggleDuplicateModal}
              // style={
              //   currentUserId === selectedUserData.id
              //     ? {
              //       pointerEvents: "none",
              //       opacity: 0.5,
              //     }
              //     : {}
              // }
              >
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={duplicatePlusIcon}
                />
                Duplicate User
              </Dropdown.Item>
            )}
            {isDeletePermitted && (
              <Dropdown.Item onClick={toggleModal}
              // style={
              //   currentUserId === selectedUserData.id
              //     ? {
              //       pointerEvents: "none",
              //       opacity: 0.5,
              //     }
              //     : {}
              // }
              >
                <ReactSVG className="svg-box" wrapper="span" src={deleteicon} />
                Delete
              </Dropdown.Item>
            )}
            {isInactivePermitted && (
              <Dropdown.Item onClick={updateStatus}
              // style={
              //   currentUserId === selectedUserData.id
              //     ? {
              //       pointerEvents: "none",
              //       opacity: 0.5,
              //     }
              //     : {}
              // }
              >
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={deactivateicon}
                />
                {selectedUserData?.isActive ? "Deactivate" : "Activate"}
              </Dropdown.Item>
            )}
            {isResetPasswordPermitted && (
              <Dropdown.Item onClick={openConfirmResetModal}>
                <ReactSVG
                  style={{ marginLeft: "-3px" }}
                  className="svg-box"
                  wrapper="span"
                  src={resetpasswordicon}
                />
                Reset Password
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <Modal id="statusmodal" show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Image src={statusmodalimage} alt="" />
          <h4>
            Are you sure you want to <br></br>approve this user?
          </h4>
          <p>rachel.steward@test.com</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Approve
          </Button>
        </Modal.Footer>
      </Modal>
      <DeleteConfModel
        showModal={showModal}
        toggleModal={onClose}
        deleteAction={deleteUser}
        modelName={`User`}
        recordName={selectedUserData.email || ""}
      />
      <DublicateUserModel
        selectedUser={selectedUserData}
        showModal={showDuplicateModal}
        toggleDuplicateModal={toggleDuplicateModal}
        redirect={'/users'}
        userList={usersList}
      />
      {showConfirmResetModal && (
        <CustomModal
          title="Confirm Reset Password"
          onClose={closeConfirmResetModal}
          content={
            <div className="confirm-reset-password-modal-content">
              <p>
                Are you sure you want to reset the password for{" "}
                <strong>{selectedUserData.email || selectedUserData.userName}</strong>?
              </p>
              {configData?.recaptchaSiteKey && (
                <div className="recaptcha-wrapper">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={configData.recaptchaSiteKey}
                    onChange={(token) => setCaptchaToken(token)}
                    onExpired={() => setCaptchaToken(null)}
                    onErrored={() => setCaptchaToken(null)}
                  />
                </div>
              )}
              <div className="modal--action--btn--wrapper">
                <Button variant="outline-primary" onClick={closeConfirmResetModal}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={resetPassword}
                  disabled={!captchaToken}
                >
                  Confirm
                </Button>
              </div>
            </div>
          }
        />
      )}
      {showResetPasswordModal && (
        <CustomModal
          title="Reset Password"
          onClose={closeResetPasswordModal}
          content={
            <div className="reset-password-modal-content">
              <p>Password has been reset successfully.</p>
              <div className="reset-password-value-wrapper">
                <span className="reset-password-value">{resetPasswordResult}</span>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="copy-password-tooltip">{copyTooltipText}</Tooltip>}
                >
                  <span className="k-cursor-pointer" onClick={handleCopyPassword}>
                    <ReactSVG className="svg-box" wrapper="span" src={duplicateIcon} />
                  </span>
                </OverlayTrigger>
              </div>
            </div>
          }
        />
      )}
    </div>
  );
};

export default UserProfileHeader;
